module.exports = __webpack_public_path__ + "static/epic_tail_whip-4d07b259cff851704cec9475e8ba7d9b.jpg";